import {TEntity, TFileInfo} from 'modules/data';

export const isDocsChosen = (selectedRows: TEntity[]): boolean => selectedRows.length > 0;

export const hasAttorneyName = (selectedRows: TEntity[]): boolean => !selectedRows.every(row => {
    const listOfFiles: TFileInfo[] = row.fileList as TFileInfo[];
    const [firstFile] = listOfFiles;
    return !firstFile?.loaSignFileName;
});
